import { render } from "./DescriptonInfo.vue?vue&type=template&id=5a62a654&scoped=true"
import script from "./DescriptonInfo.vue?vue&type=script&lang=js"
export * from "./DescriptonInfo.vue?vue&type=script&lang=js"

import "./DescriptonInfo.vue?vue&type=style&index=0&id=5a62a654&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a62a654"]])

export default __exports__